import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import {
  CurrencyComponent,
  ImageThumbnailComponent,
  NumberComponent,
} from '@web/shared/ui';
import {
  RefundedPriceComponent,
  RefundedQuantityComponent,
} from '@web/shared/module/shop';
import { isNil, isNotNil } from '@web/utils';
import { AdminOrderItem } from '../../models/admin-order-item';
import { AdminOrderItemComponentGroupsComponent } from '../admin-order-item-component-groups/admin-order-item-component-groups.component';

@Component({
  selector: 'app-admin-order-item-card',
  imports: [
    AdminOrderItemComponentGroupsComponent,
    CurrencyComponent,
    ImageThumbnailComponent,
    NgOptimizedImage,
    NumberComponent,
    RefundedPriceComponent,
    RefundedQuantityComponent,
  ],
  templateUrl: './admin-order-item-card.component.html',
  styleUrl: './admin-order-item-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminOrderItemCardComponent {
  public readonly count = input.required<number>();
  public readonly index = input.required<number>();
  public readonly item = input.required<AdminOrderItem>();

  protected readonly isNil = isNil;
  protected readonly isNotNil = isNotNil;
}
